/* eslint-disable max-lines */
/* eslint-disable no-shadow */
import { call, takeEvery } from "redux-saga/effects";
import {
  getId,
  injectApiWithContextFactory,
  injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";
import noop from "lodash.noop";
import {
  loadSysConfig,
  updateEnvChains,
  updateSysChainDocumentBuilder,
} from "./sysconfig.api";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";
import { v4 as uuidv4 } from "uuid";
import {
  SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_REQUEST,
  SYSCONFIG_ENV_CHAINS_UPDATE_REQUEST,
  SYSCONFIG_LOAD_REQUEST,
  loadFail,
  loadSuccess,
  updateDocumentBuilderChainFail,
  updateDocumentBuilderChainSuccess,
} from "./sysconfig.duck";

export const withBoundActions = injectBoundActionCreatorsFactory(
  {
    loadFail,
    loadSuccess,
    updateDocumentBuilderChainFail,
    updateDocumentBuilderChainSuccess,
  },
  () => "sysconfig"
);

export const withApiContext = injectApiWithContextFactory(
  { loadSysConfig, updateSysChainDocumentBuilder, updateEnvChains },
  injectBoundGQLClient
);

function* loadSysConfigSaga({
  api: { loadSysConfig = noop },
  actions: { loadSuccess, loadFail },
  resolve = noop,
  reject = noop,
}) {
  try {
    const result = yield loadSysConfig();
    // if (result === null || !result) {
    //     const { chain, systemChain } = defaultChainInstance();
    //     result = yield upsertChainInstance({ chain: chain(), systemChain: systemChain() });
    // }
    yield loadSuccess(result);
    yield call(resolve);
  } catch (error) {
    yield loadFail(error);
    yield call(reject, error);
  }
}

function* updateSysConfigDocumentBuilderChains({
  data: { systemChain },
  api: { updateSysChainDocumentBuilder = noop, loadSysConfig = noop },
}) {
  const ensureIdInSystemChain = systemChain.map(obj => {
    return obj.hasOwnProperty("id") ? obj : { ...obj, id: uuidv4() };
  });

  const isOk = yield updateSysChainDocumentBuilder({
    chains: ensureIdInSystemChain,
  });
  if (isOk) {
    yield loadSysConfig();
  }
}

function* updateSysConfigEnvChains({
  data: { chains },
  api: { updateEnvChains = noop, loadSysConfig = noop },
}) {
  const isOk = yield updateEnvChains({ chains });
  if (isOk) {
    yield loadSysConfig();
  }
}

export default () =>
  function* rootSaga() {
    yield takeEvery(
      SYSCONFIG_LOAD_REQUEST,
      withApiContext(withBoundActions(loadSysConfigSaga))
    );
    yield takeEvery(
      SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_REQUEST,
      withApiContext(
        withBoundActions(updateSysConfigDocumentBuilderChains)
      )
    );
    yield takeEvery(
      SYSCONFIG_ENV_CHAINS_UPDATE_REQUEST,
      withApiContext(withBoundActions(updateSysConfigEnvChains))
    );
  };
